interface IAction {
  type: string;
  payload: {
    [key: string]: number;
  };
}

type TProducts = {
  [key: string]: number;
};

interface IState {
  productsCount: number;
  selectedProducts: TProducts;
}

const initialState: IState = {
  productsCount: 0,
  selectedProducts: {},
};

export const selectedProductsReducer = (
  state = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case 'ADD_ITEM_ACTION':
      return {
        ...state,
        productsCount: state.productsCount + 1,
        selectedProducts: { ...action.payload },
      };

    case 'REMOVE_ITEM_ACTION':
      return {
        ...state,
        productsCount: state.productsCount - 1,
        selectedProducts: { ...action.payload },
      };

    case 'POPULATE_STARTER_KIT':
      return {
        ...state,
        productsCount: Object.keys(action.payload).length,
        selectedProducts: { ...action.payload },
      };

    default:
      return state;
  }
};

export const addItemAction = (selectedProducts: TProducts, id: string) => {
  return {
    type: 'ADD_ITEM_ACTION',
    payload: {
      ...selectedProducts,
      [`${id}`]: id in selectedProducts ? selectedProducts[id] + 1 : 1,
    },
  };
};

export const removeItemAction = (selectedProducts: TProducts, id: string) => {
  let updatedState: TProducts;

  if (selectedProducts[id] === 1) {
    const updatedProducts = { ...selectedProducts };
    delete updatedProducts[id];
    updatedState = {
      ...updatedProducts,
    };
  } else {
    updatedState = {
      ...selectedProducts,
      [`${id}`]: selectedProducts[id] - 1,
    };
  }

  return {
    type: 'REMOVE_ITEM_ACTION',
    payload: updatedState,
  };
};

export const populateStarterKitProducts = (ids: string[]) => {
  const populatedProducts = ids.reduce(
    (accum: Record<string, number>, id) => ((accum[id] = 1), accum),
    {}
  );

  return { type: 'POPULATE_STARTER_KIT', payload: populatedProducts };
};
